module.exports = ol.style.Circle;